import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_ORANGE,
    codeProp: 'acUserCode',
    mapProp: 'acMap',
    name: '分析口径',
    ownerIdProp: 'aiId',
    ownerTextProp: 'aiName',
    ownerType: 'AMAI',
    textProp: 'acName',
    type: 'AIAC',
}
